import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Get page title from document or generate from path
    const pageTitle = document.title || generateTitleFromPath(location.pathname);
    
    // Track page view
    trackPageView(window.location.href, pageTitle);
  }, [location]);
};

// Helper function to generate title from pathname for better tracking
const generateTitleFromPath = (pathname: string): string => {
  const pathSegments = pathname.split('/').filter(Boolean);
  
  if (pathSegments.length === 0) return 'Home - BlueLux';
  
  // Convert path segments to readable titles
  const titles = pathSegments.map(segment => 
    segment
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  );
  
  return `${titles.join(' - ')} - BlueLux`;
};